// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v3iS","content":"styles_content__1KAP7","footText":"styles_footText__3eq_U"};